import fetch from "../../auth/FetchInterceptor";

export const getOverviewDashboard = function () {
  return fetch({
    url: `/dashboards/overview`,
    method: 'get'
  })
}